let mockShiftSchedules = [
  {
    id: 1,
    shiftNameEn: 'Morning to evening',
    shiftNameAr: 'فينكاتيش',
    code: '100',
    timeTable: 'Morning',
    unit: 'Month',
    cycle: 1,
    autoShift: "Yes",
    color:"#f0f9ff",
  },
  {
    id: 2,
    shiftNameEn: 'Night Shift',
    shiftNameAr: 'حازم نعيم',
    code: '125',
    timeTable: 'Morning',
    unit: 'Week',
    cycle: 1,
    autoShift: "No",
    color:"#198754",
  },
  {
    id: 3,
    shiftNameEn: 'Shift 20250710-2',
    shiftNameAr: 'سودييش',
    code: '101',
    timeTable: 'Evening',
    unit: 'Day',
    cycle: 1,
    autoShift: "Yes",
    color:"#dc3545",
  },
  {
    id: 4,
    shiftNameEn: 'Shift 20250710-5',
    shiftNameAr: 'شيراچ',
    code: '110',
    timeTable: 'Afternoon',
    unit: 'Week',
    cycle: 1,
    autoShift: "No",
    color:"#198754",
  },
  {
    id: 5,
    shiftNameEn: 'Rotating Day Shift',
    shiftNameAr: 'وردية النهار الدوارة',
    code: '201',
    timeTable: 'Morning',
    unit: 'Day',
    cycle: 7,
    autoShift: "Yes",
    color:"#fff3cd",
  },
  {
    id: 6,
    shiftNameEn: 'Weekend Special',
    shiftNameAr: 'نهاية الأسبوع الخاصة',
    code: '205',
    timeTable: 'Evening',
    unit: 'Week',
    cycle: 2,
    autoShift: "No",
    color:"#d1ecf1",
  },
  {
    id: 7,
    shiftNameEn: 'Emergency Coverage',
    shiftNameAr: 'التغطية الطارئة',
    code: '300',
    timeTable: 'Night',
    unit: 'Day',
    cycle: 1,
    autoShift: "Yes",
    color:"#f8d7da",
  },
  {
    id: 8,
    shiftNameEn: 'Holiday Shift',
    shiftNameAr: 'وردية العطل',
    code: '400',
    timeTable: 'Afternoon',
    unit: 'Month',
    cycle: 12,
    autoShift: "No",
    color:"#e2e3e5",
  },
  {
    id: 9,
    shiftNameEn: 'Flexi-Time',
    shiftNameAr: 'الوقت المرن',
    code: '150',
    timeTable: 'Morning',
    unit: 'Week',
    cycle: 4,
    autoShift: "Yes",
    color:"#d4edda",
  },
  {
    id: 10,
    shiftNameEn: '24-Hour Rotation',
    shiftNameAr: 'التناوب 24 ساعة',
    code: '500',
    timeTable: 'Night',
    unit: 'Day',
    cycle: 3,
    autoShift: "Yes",
    color:"#cce7ff",
  },
  {
    id: 11,
    shiftNameEn: 'Split Shift A',
    shiftNameAr: 'وردية منقسمة أ',
    code: '601',
    timeTable: 'Afternoon',
    unit: 'Week',
    cycle: 1,
    autoShift: "No",
    color:"#f5f5f5",
  }
];


let idCounter = 12;

const ShiftScheduleAPI = {
  getAll: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ data: { data: [...mockShiftSchedules] } });
      }, 300);
    });
  },

  add: async (newData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newItem = { ...newData, id: idCounter++ };
        mockShiftSchedules = [...mockShiftSchedules, newItem];

        resolve({ data: { data: newItem } });
      }, 300);
    });
  },

  update: async (id, updatedData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockShiftSchedules.findIndex((item) => item.id === id);
        if (index !== -1) {
          mockShiftSchedules[index] = {
            ...mockShiftSchedules[index],
            ...updatedData,
          };
          resolve({ data: { data: mockShiftSchedules[index] } });
        }
      }, 300);
    });
  },

  delete: async (ids) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const idsToDelete = Array.isArray(ids) ? ids : [ids];
        const initialLength = mockShiftSchedules.length;
        mockShiftSchedules = mockShiftSchedules.filter(
          (item) => !idsToDelete.includes(item.id)
        );

        resolve({
          status: 200,
          data: {
            deletedCount: idsToDelete.length,
            deletedIds: idsToDelete,
          },
        });
      }, 300);
    });
  },
};

export default ShiftScheduleAPI;
